export default __webpack_public_path__ + "static/2-724949afeb447ea9316d5f93b42bf36d.png";